export enum AppRoutingInterceptors {
  OnOpeningDetails = 'OnOpeningDetails',
  OnClosingDetails = 'OnClosingDetails',
}
